import React from 'react'
import {
  FormInputSelect,
  FormInput
} from 'camino-react'
import _ from 'lodash'

class Queue extends React.Component {
  constructor (props) {
    super()
  }

  render () {
    const {
      editedItem,
      queues,
      queueDisabled,
      valueDisabledQueue,
      setValueOfDisabledAssigneeQueues,
      resetAssigneeToDefault
    } = this.props

    return (
      <div>
        <FormInput>
          <div key={editedItem.firstValueId}>
            <div>
              <FormInputSelect
                placeholder="Queue"
                disabled={queueDisabled}
                value={_.find(queues, ({ value: queueDisabled ? valueDisabledQueue : editedItem.queueId }))}
                isLoading={_.isEmpty(queues)}
                options={queues}
                onValue={(value) => {
                  editedItem.updateOptionValue('queueId', value)
                  setValueOfDisabledAssigneeQueues(value)
                  resetAssigneeToDefault()
                }}
                clearable
                name="editedItem[queueId]"
                id="queueId"
              />
            </div>
          </div>
        </FormInput>
      </div>
    )
  }
}

export default Queue
